import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import HomepageTemplate from 'gatsby-theme-carbon/src/templates/Homepage';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = HomepageTemplate;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Get Started`}</h2>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Overview" subTitle="Cloud Pak for Integration Overview" href="/overview" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARASEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAwABAgT/xAAXAQADAQAAAAAAAAAAAAAAAAAAAQME/9oADAMBAAIQAxAAAAHJcE6JiRqP/8QAGRABAQEAAwAAAAAAAAAAAAAAAQACAxEh/9oACAEBAAEFAsk5mN9TyMvv/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQAGPwJf/8QAGhAAAwEAAwAAAAAAAAAAAAAAAQARIUFRkf/aAAgBAQABPyG/HrMZENTBA95ISL//2gAMAwEAAgADAAAAEEvf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFxEBAAMAAAAAAAAAAAAAAAAAAAEhMf/aAAgBAgEBPxCMU//EABwQAQADAAIDAAAAAAAAAAAAAAERACExYUGRwf/aAAgBAQABPxBuDzypLIvZlCc89xTSO6wH2wU4HuzY1dv/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "concepts",
              "title": "concepts",
              "src": "/cp4i-demohub/static/56c374949d1a87aaa9c384613570bb3e/2e753/concepts.jpg",
              "srcSet": ["/cp4i-demohub/static/56c374949d1a87aaa9c384613570bb3e/69549/concepts.jpg 288w", "/cp4i-demohub/static/56c374949d1a87aaa9c384613570bb3e/473e3/concepts.jpg 576w", "/cp4i-demohub/static/56c374949d1a87aaa9c384613570bb3e/2e753/concepts.jpg 1152w", "/cp4i-demohub/static/56c374949d1a87aaa9c384613570bb3e/74f4b/concepts.jpg 1728w", "/cp4i-demohub/static/56c374949d1a87aaa9c384613570bb3e/de5bb/concepts.jpg 2304w", "/cp4i-demohub/static/56c374949d1a87aaa9c384613570bb3e/9dba4/concepts.jpg 2800w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Early Sales Demos" subTitle="Videos and Clickthru Demos for your early sales meetings" href="/esd" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARASEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAwABBf/EABYBAQEBAAAAAAAAAAAAAAAAAAADBP/aAAwDAQACEAMQAAABhs82uNRJ/8QAGRAAAwEBAQAAAAAAAAAAAAAAAQIAERIT/9oACAEBAAEFAkA0zL0VIi23rf/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAECAQE/AYj/xAAaEAADAAMBAAAAAAAAAAAAAAARAAEhURJB/9oACAEBAAY/AtW7SA5BjiAZjy+x/8QAGxAAAgMBAQEAAAAAAAAAAAAAAREAITFBYXH/2gAIAQEAAT8hRdCpB06ArOiAoYC5awmA2FOmmUUJ6HyM/9oADAMBAAIAAwAAABDb/wD/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAwEBPxBX/8QAFxEBAAMAAAAAAAAAAAAAAAAAAAERQf/aAAgBAgEBPxCdLP/EAB4QAQEAAgICAwAAAAAAAAAAAAERIQAxYUFRkaHw/9oACAEBAAE/ECDmQg2ZXv8AZ0DmnRTBwTxjrPO5IwMRRDvVWSdI9q8/Gyk4L2BbCqBTgmhaoejT7N//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "prereqs",
              "title": "prereqs",
              "src": "/cp4i-demohub/static/85a2a1dc4c4160455f5a2086a37a04af/2e753/prereqs.jpg",
              "srcSet": ["/cp4i-demohub/static/85a2a1dc4c4160455f5a2086a37a04af/69549/prereqs.jpg 288w", "/cp4i-demohub/static/85a2a1dc4c4160455f5a2086a37a04af/473e3/prereqs.jpg 576w", "/cp4i-demohub/static/85a2a1dc4c4160455f5a2086a37a04af/2e753/prereqs.jpg 1152w", "/cp4i-demohub/static/85a2a1dc4c4160455f5a2086a37a04af/74f4b/prereqs.jpg 1728w", "/cp4i-demohub/static/85a2a1dc4c4160455f5a2086a37a04af/de5bb/prereqs.jpg 2304w", "/cp4i-demohub/static/85a2a1dc4c4160455f5a2086a37a04af/9dba4/prereqs.jpg 2800w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Get Started with CP4I on ROKS" subTitle="Setup your own Cloud Pak for Integration environment in ROKS for live demos" href="/cp4i-on-roks" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARASEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAwABBf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/9oADAMBAAIQAxAAAAHFKCuY2pf/xAAZEAADAQEBAAAAAAAAAAAAAAABAgARAzH/2gAIAQEAAQUCQXRcEGyLsY+//8QAFhEAAwAAAAAAAAAAAAAAAAAAEBEh/9oACAEDAQE/AVR//8QAFhEBAQEAAAAAAAAAAAAAAAAAEQEQ/9oACAECAQE/AUhn/8QAGBAAAwEBAAAAAAAAAAAAAAAAIQAQAQL/2gAIAQEABj8CTAnrZ//EABgQAQADAQAAAAAAAAAAAAAAAAEAITER/9oACAEBAAE/IQdmASqqJxjEaIzXg6djj//aAAwDAQACAAMAAAAQb+//xAAWEQEBAQAAAAAAAAAAAAAAAAABEQD/2gAIAQMBAT8QW1cWb//EABcRAQEBAQAAAAAAAAAAAAAAAAEAESH/2gAIAQIBAT8QDwSG3//EABoQAQEBAQADAAAAAAAAAAAAAAERAEExUWH/2gAIAQEAAT8Qv2/APOn9Q3jWDMk1BysllHE9ai3/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "multi cloud",
              "title": "multi cloud",
              "src": "/cp4i-demohub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/2e753/multi-cloud.jpg",
              "srcSet": ["/cp4i-demohub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/69549/multi-cloud.jpg 288w", "/cp4i-demohub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/473e3/multi-cloud.jpg 576w", "/cp4i-demohub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/2e753/multi-cloud.jpg 1152w", "/cp4i-demohub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/74f4b/multi-cloud.jpg 1728w", "/cp4i-demohub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/de5bb/multi-cloud.jpg 2304w", "/cp4i-demohub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/9dba4/multi-cloud.jpg 2800w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Sales Demos" subTitle="Usecase driven Sales Demos" href="/community" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARASEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAABAABAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAcYsOwHZdT//xAAbEAACAQUAAAAAAAAAAAAAAAABAgADBBESIf/aAAgBAQABBQJVJlyqgmI2rVDmHp//xAAVEQEBAAAAAAAAAAAAAAAAAAAQQf/aAAgBAwEBPwGH/8QAFREBAQAAAAAAAAAAAAAAAAAAEEH/2gAIAQIBAT8Bp//EABkQAQADAQEAAAAAAAAAAAAAAAEAAhAhEf/aAAgBAQAGPwIDvZUK+OEM/8QAGhAAAwEBAQEAAAAAAAAAAAAAAREAITFhgf/aAAgBAQABPyFSGOF2IgRpfZHl5B7GIi/pjJCe3//aAAwDAQACAAMAAAAQf8//xAAXEQADAQAAAAAAAAAAAAAAAAABECFh/9oACAEDAQE/EIdL/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAh/9oACAECAQE/ENIl/8QAHBABAQACAwEBAAAAAAAAAAAAAREAIUFRgWGx/9oACAEBAAE/EICBbNH8PcWxbSj3y4OWH1xULGVBsnWKm2raauicYpdTV7z/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "lecture cloud",
              "title": "lecture cloud",
              "src": "/cp4i-demohub/static/293d77f2c1d63f494bb018704697e935/2e753/lecture-cloud.jpg",
              "srcSet": ["/cp4i-demohub/static/293d77f2c1d63f494bb018704697e935/69549/lecture-cloud.jpg 288w", "/cp4i-demohub/static/293d77f2c1d63f494bb018704697e935/473e3/lecture-cloud.jpg 576w", "/cp4i-demohub/static/293d77f2c1d63f494bb018704697e935/2e753/lecture-cloud.jpg 1152w", "/cp4i-demohub/static/293d77f2c1d63f494bb018704697e935/74f4b/lecture-cloud.jpg 1728w", "/cp4i-demohub/static/293d77f2c1d63f494bb018704697e935/de5bb/lecture-cloud.jpg 2304w", "/cp4i-demohub/static/293d77f2c1d63f494bb018704697e935/9dba4/lecture-cloud.jpg 2800w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Learn with Labs" subTitle="Explore or Demo Cloud Pak for Integration Capabilities" href="/tutorials" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARASEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAgADBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAByZhMrosf/8QAGhAAAwEAAwAAAAAAAAAAAAAAAQIAAxESIv/aAAgBAQABBQIE5wbhX9Nme0yGJv/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABsQAAMAAgMAAAAAAAAAAAAAAAERABASIUFR/9oACAEBAAY/Aiu4oKZtZDn3H//EABoQAQEBAQADAAAAAAAAAAAAAAERACExUWH/2gAIAQEAAT8hlOPFfmsQDxl7k2upofZwC1C9Zbv/2gAMAwEAAgADAAAAEMc//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHBABAAICAwEAAAAAAAAAAAAAAREAITFBgWGR/9oACAEBAAE/EA0sEU7HdhkjPEHMOdSXXlJmXisSYwCmqNgyGinPyheY8jV//9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "activities",
              "title": "activities",
              "src": "/cp4i-demohub/static/1410eb967b065107d7bf4d231bf356d0/2e753/activities.jpg",
              "srcSet": ["/cp4i-demohub/static/1410eb967b065107d7bf4d231bf356d0/69549/activities.jpg 288w", "/cp4i-demohub/static/1410eb967b065107d7bf4d231bf356d0/473e3/activities.jpg 576w", "/cp4i-demohub/static/1410eb967b065107d7bf4d231bf356d0/2e753/activities.jpg 1152w", "/cp4i-demohub/static/1410eb967b065107d7bf4d231bf356d0/74f4b/activities.jpg 1728w", "/cp4i-demohub/static/1410eb967b065107d7bf4d231bf356d0/de5bb/activities.jpg 2304w", "/cp4i-demohub/static/1410eb967b065107d7bf4d231bf356d0/9dba4/activities.jpg 2800w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Contribute" subTitle="Submit your requests or contributions" href="/contribute" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARASEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMBBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAeZsxRAf/8QAGRAAAgMBAAAAAAAAAAAAAAAAABEBAhAh/9oACAEBAAEFApRXGcGf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFhABAQEAAAAAAAAAAAAAAAAAMQAg/9oACAEBAAY/AmM//8QAGhAAAgIDAAAAAAAAAAAAAAAAAQARMUFRYf/aAAgBAQABPyHAgMXSCDTRntnt/9oADAMBAAIAAwAAABAYz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABsQAQEAAgMBAAAAAAAAAAAAAAERACExYVGx/9oACAEBAAE/EDWt6jbgTEO1fmLNy7DExL5bx1iBxJwoax9Gf//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "resources",
              "title": "resources",
              "src": "/cp4i-demohub/static/67096b3ce1e6b0e558944f514b626cca/2e753/resources.jpg",
              "srcSet": ["/cp4i-demohub/static/67096b3ce1e6b0e558944f514b626cca/69549/resources.jpg 288w", "/cp4i-demohub/static/67096b3ce1e6b0e558944f514b626cca/473e3/resources.jpg 576w", "/cp4i-demohub/static/67096b3ce1e6b0e558944f514b626cca/2e753/resources.jpg 1152w", "/cp4i-demohub/static/67096b3ce1e6b0e558944f514b626cca/74f4b/resources.jpg 1728w", "/cp4i-demohub/static/67096b3ce1e6b0e558944f514b626cca/de5bb/resources.jpg 2304w", "/cp4i-demohub/static/67096b3ce1e6b0e558944f514b626cca/9dba4/resources.jpg 2800w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      